import { CommonModule } from '@angular/common';
import { Component, computed, signal, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Pays, User } from '@models/user.model';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';
import { User as UserService } from '@services/user.service';

@Component({
  selector: 'lgb-user-list',
  imports: [
    UiModule,
    CommonModule,
    RouterModule,
    FormsModule
  ],  
  templateUrl: './user-list.html',
  styleUrl: './user-list.css',
})
export class UserList {
  readonly loading=signal<boolean>(false);
  readonly searching=signal<boolean>(true);
  readonly completeLoad=computed(() => !this.loading() && !this.searching());

  //data
  readonly users=signal<User[]>([]);
  readonly pays=signal<Pays[]>([]);
  readonly qSearch=signal<string>(null);

  //service
  readonly userService=inject(UserService);
  readonly global=inject(Global);
  readonly router=inject(Router);

  constructor(){
    this.loading.set(true);
    this.global.getPays()
      .subscribe(pays => {
        this.pays.set(pays);
        this.loading.set(false);
      });
  }

  //retourne l'observable pour la 
  getSearchObs(){
    return (q: string, start: number, length: number) => this.userService.search(q, start, length);
  }

  getPays(pays: number){
    return this.pays().filter(p => p.id==pays)[0];
  }
}
